var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.902 4.45L6.97 3.93a1 1 0 00-1.931-.517h-.002l-1.78 6.642A5.475 5.475 0 016.5 8.998a5.497 5.497 0 014.682 2.614A2.986 2.986 0 0113 10.997c.683 0 1.313.229 1.818.614A5.497 5.497 0 0119.5 8.997c1.212 0 2.333.392 3.242 1.057l-1.78-6.642h-.002a1 1 0 00-1.931.518l-1.932.518a3 3 0 015.795-1.556h.001l3.104 11.584.003.001V14.798a.2.2 0 01-.2.2H24.978a5.5 5.5 0 01-10.956-1H14a1 1 0 10-2 0h-.022a5.5 5.5 0 01-10.955 1H.2a.2.2 0 01-.2-.2V14.478h.002L3.106 2.893h.001A3 3 0 018.902 4.45zM6.5 17.997a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm13 0a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
  })));
}

export default __webpack_public_path__ + "1f15dffbe33f1286f9a5d9659b3c382c.svg";
export { SvgReview as ReactComponent };